// this is an autogenerated file from DesignSystem/AutomationTask/Actions/Content/Action/DocumentTemplate/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_AutomationTask_Actions_Content_Action_DocumentTemplate($location_id: uuid!) {
  vaxiom_document_templates(
    where: { organization: { _id: { _eq: $location_id } } }
    order_by: { name: asc_nulls_last }
  ) {
    vaxiom_id: id
    id: _id
    text: name
  }
}

`